"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transferContractOwnership = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const config_1 = require("../config/config");
const constants_1 = require("../constants");
const types_1 = require("../types");
/**
 * Transfers one or more tokens to specified recipients.
 * @param transferContractOwnershipArgs {@link TransferContractOwnershipArgumentsArgs}
 * @returns contract call to be passed to @mintbase-js/sdk execute method
 */
const transferContractOwnership = (args) => {
    const { contractAddress, nextOwner, options = { keepMinters: true } } = args;
    return {
        contractAddress: contractAddress || config_1.mbjs.keys.contractAddress,
        args: {
            new_owner: nextOwner,
            keep_old_minters: options.keepMinters,
        },
        methodName: types_1.TOKEN_METHOD_NAMES.TRANSFER_TOKEN_CONTRACT_OWNERSHIP,
        gas: constants_1.GAS,
        deposit: constants_1.ONE_YOCTO,
    };
};
exports.transferContractOwnership = transferContractOwnership;
//# sourceMappingURL=transferContractOwnership.js.map